import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { Select, message } from 'antd';
import NumberFormat from 'react-number-format';

import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { userAssociatedFacilities, downloadOpenExamsList } from '../../../common/services/ApiService';

import Axios from '../../../config/axios';

import Moment from 'moment';

import { toast } from '@rickylandino/react-messages';

class OpenExamsReportModal extends Component {
    constructor(props) {
        super(props);

        var minus7 = new Date();
        minus7.setDate(minus7.getDate() - 7);

        var twoYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 2))

        this.state = {
            showModal: props.showModal,
            allFacilities: [],
            selectedFacilities: [],
            availableBirads: [],
            selectedBirads: [],
            selectedDates: {
                startDate: twoYearsAgo,
                endDate: new Date()
            }
        }

        this.alive = false;
    }

    componentDidMount() {
        this.alive = true;

        combineLatest(
            userAssociatedFacilities
        ).pipe(takeWhile(() => this.alive)).subscribe(([f]) => {
            if (f?.length > 0) {

                let selectedFacilities = [];

                if (f.length === 1) {
                    selectedFacilities = [f[0].facilityModel.facilityID];
                }

                this.setState({
                    allFacilities: f,
                    selectedFacilities,
                    loaded: true
                }, () => {
                        if (f.length === 1) {
                            this.handleFacilityChange(selectedFacilities);
                        }
                    
                });
            }
        });
    }

    componentWillUnmount() {
        this.alive = false;
    }

    handleFacilityChange = (selectedFacilities) => {
        // Check if "Select All" was just selected
        if (selectedFacilities.includes("Select All") && !this.state.selectedFacilities.includes("Select All")) {
            // Select all available facilities
            const allFacilityIds = this.state.allFacilities.map(f => f.facilityModel.facilityID);
            this.setState({
                selectedFacilities: allFacilityIds
            }, () => {
                // After selecting all facilities, update available BIRADS
                this.updateAvailableBirads(allFacilityIds);
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedFacilities.includes("Select All") && this.state.selectedFacilities.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedFacilities: [],
                availableBirads: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedFacilities.includes("Select All") && selectedFacilities.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredFacilities = selectedFacilities.filter(f => f !== "Select All");
            this.setState({
                selectedFacilities: filteredFacilities
            }, () => {
                this.updateAvailableBirads(filteredFacilities);
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualFacilities = this.state.allFacilities.map(f => f.facilityModel.facilityID);
            const hasAllItems = allIndividualFacilities.every(facility => selectedFacilities.includes(facility));
            
            if (hasAllItems && allIndividualFacilities.length === selectedFacilities.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedFacilities: ["Select All", ...selectedFacilities]
                }, () => {
                    this.updateAvailableBirads(selectedFacilities);
                });
            } else {
                // Regular selection
                this.setState({
                    selectedFacilities: selectedFacilities
                }, () => {
                    this.updateAvailableBirads(selectedFacilities);
                });
            }
        }
    }

    updateAvailableBirads = (selectedFacilities) => {
        // Filter out "Select All" for BIRADS processing
        const facilitiesForBirads = selectedFacilities.filter(f => f !== "Select All");
        
        if (facilitiesForBirads.length === 0) {
            this.setState({ availableBirads: [] });
            return;
        }

        if (facilitiesForBirads.length === 1) {
            let availableBirads = this.state.allFacilities.find(f => f.facilityModel.facilityID === facilitiesForBirads[0])?.availableBirads;
            this.setState({ availableBirads });
        } else {
            //create list with all birads, including duplicates
            let concatBirads = [];
            facilitiesForBirads.forEach(f => {
                let facBirads = this.state.allFacilities.find(fac => fac.facilityModel.facilityID === f)?.availableBirads;
                concatBirads = concatBirads.concat(facBirads);
            });

            //filter duplicates out so we are left with only unique birads
            const seen = new Set();

            const availableBirads = concatBirads.filter(el => {
                const duplicate = seen.has(el.birads);
                seen.add(el.birads);
                return !duplicate;
            });

            //sort by alphabetical order
            availableBirads.sort(function (a, b) {
                var nameA = a.birads.toUpperCase(); // ignore upper and lowercase
                var nameB = b.birads.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });

            this.setState({ availableBirads });
        }
    }

    handleBiradChange = (selectedBirads) => {
        // Check if "Select All" was just selected
        if (selectedBirads.includes("Select All") && !this.state.selectedBirads.includes("Select All")) {
            // Select all available BIRADS including "No Result Entered"
            const allBirads = ["No Result Entered", ...this.state.availableBirads.map(b => b.birads)];
            this.setState({
                selectedBirads: allBirads
            });
        }
        // Check if "Select All" was deselected (removed)
        else if (!selectedBirads.includes("Select All") && this.state.selectedBirads.includes("Select All")) {
            // Clear all selections
            this.setState({
                selectedBirads: []
            });
        }
        // Check if "Select All" is currently selected but user selected/deselected individual items
        else if (this.state.selectedBirads.includes("Select All") && selectedBirads.includes("Select All")) {
            // Remove "Select All" from the selection and keep individual selections
            const filteredBirads = selectedBirads.filter(b => b !== "Select All");
            this.setState({
                selectedBirads: filteredBirads
            });
        }
        // Normal selection without "Select All"
        else {
            // Check if all individual items are now selected
            const allIndividualBirads = ["No Result Entered", ...this.state.availableBirads.map(b => b.birads)];
            const hasAllItems = allIndividualBirads.every(birad => selectedBirads.includes(birad));

            if (hasAllItems && allIndividualBirads.length === selectedBirads.length) {
                // All items are selected, so show "Select All" as selected too
                this.setState({
                    selectedBirads: ["Select All", ...selectedBirads]
                });
            } else {
                // Regular selection
                this.setState({
                    selectedBirads: selectedBirads
                });
            }
        }
    }

    handleClear = () => {
        this.setState({
            selectedFacilities: [],
            selectedBirads: [],
            availableBirads: [],
            selectedDates: {
                startDate: null,
                endDate: new Date()
            }
        })
    }

    handleNewDateChange = (name, date) => {
        this.setState({ selectedDates: { ...this.state.selectedDates, [name]: date } });
    }

    handleSubmit = () => {

        let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;

        // Filter out "Select All" from selected values before submitting
        const facilitiesValue = this.state.selectedFacilities.filter(f => f !== "Select All");
        const biradValues = this.state.selectedBirads.filter(b => b !== "Select All");

        if (facilitiesValue.length > 0 && this.state.selectedBirads.length > 0) {
            const q = Axios.defaults.baseURL + "api/RenderOpenExamReport";

            var form = document.createElement("form");
            form.target = "_blank";
            form.method = "POST";
            form.action = q;
            form.style.display = "none";

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "startDate";
            input.value = startDate;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "endDate";
            input.value = endDate;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "selectedFacilies";
            input.value = facilitiesValue;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "birads";
            input.value = biradValues;
            form.appendChild(input);

            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "ianaTimezone";
            input.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
            form.appendChild(input);

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        } else {
            toast.error("Please fill in all required fields.");
        }

    }

    exportExcel = () => {
        let endDate = this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null;
        let startDate = this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null;

        // Filter out "Select All" from selected values before submitting
        const facilitiesValue = this.state.selectedFacilities.filter(f => f !== "Select All");
        const biradValues = this.state.selectedBirads.filter(b => b !== "Select All");

        if (facilitiesValue.length > 0 && this.state.selectedBirads.length > 0) {
            const key = "loading";
            message.loading({ content: 'Exporting Open Exams...', key, duration: 0 });
            let fileName = "open-exams_" + Moment().format('YYYYMMDDHm') + '.xlsx';

            let postdata = {
                fileName,
                sDate: this.state.selectedDates.startDate ? Moment(this.state.selectedDates.startDate).format("YYYY-MM-DD") : null,
                eDate: this.state.selectedDates.endDate ? Moment(this.state.selectedDates.endDate).format("YYYY-MM-DD") : null,
                facilities: facilitiesValue,
                birads: biradValues,
                ianaTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
            }

            downloadOpenExamsList(postdata).then(data => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = fileName;//"File.xlsx";
                //document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);

                message.destroy(key);

                this.setState({
                    downloading: false
                })
            }).catch(error => {
                console.log("Error");
            });
        } else {
            toast.error("Please fill in all required fields.");
        }
    }

    handleFilterCustom = (input, option) => {
        //console.log(input);
        //console.log(option);
    }


    render() {

        const { Option } = Select;

        const theme = window.sessionStorage.getItem("theme");

        return (
            <Modal size='lg' show={this.state.showModal} onHide={this.toggleModal} backdrop='static' dialogClassName={theme === 'dark' ? 'dark-theme' : 'light-theme'}>
                <Modal.Header>
                    <h1>Open Exams</h1>
                </Modal.Header>
                <Modal.Body className="no-y-overflow">
                    <div className="panel-content">
                        {this.state.loaded &&
                            <div className="row">

                                <div className="form-group col col-6">
                                    <div className="form-label">Start Range</div>
                                    <DatePicker
                                        onChange={(date) => this.handleNewDateChange('startDate', date)}
                                        selectsStart
                                        startDate={this.state.selectedDates.startDate}
                                        endDate={this.state.selectedDates.endDate}
                                        className="form-control-custom"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                        placeholderText='Start Date'
                                        selected={this.state.selectedDates.startDate && Moment(this.state.selectedDates.startDate).toDate()}
                                        customInput={
                                            <NumberFormat format="##/##/####" mask="_" />
                                        }
                                    />
                                </div>
                                <div className="col col-6">
                                    <div className="form-label">End Range</div>
                                    <DatePicker
                                        onChange={(date) => this.handleNewDateChange('endDate', date)}
                                        selectsEnd
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                        startDate={this.state.selectedDates.startDate}
                                        endDate={this.state.selectedDates.endDate}
                                        className="form-control-custom"
                                        placeholderText='End Date'
                                        selected={this.state.selectedDates.endDate && Moment(this.state.selectedDates.endDate).toDate()}
                                        customInput={
                                            <NumberFormat format="##/##/####" mask="_" />
                                        }
                                    />

                                </div>
                                <div className="form-group col col-lg-6 col-12">
                                <div className="form-label">Facility <span className="color-pink">*</span></div>
                                {this.state.allFacilities.length === 1 ?
                                    <div>{this.state.allFacilities[0].facilityModel.facilityName}</div>
                                    :
                                    <Select
                                        mode="multiple"
                                        maxTagCount={2}
                                        allowClear
                                        placeholder="Please select"
                                        onChange={this.handleFacilityChange}
                                        className="form-control-custom w-100"
                                        bordered={false}
                                        virtual={false}
                                        value={this.state.selectedFacilities}
                                        showSearch
                                        filterOption={(input, option) => (option.children[0] + option.children[1]).toLowerCase().includes(input.toLowerCase())}
                                    >
                                        <Option key="Select All" value="Select All">Select All</Option>
                                        {this.state.allFacilities.map((fac, idx) => <Option key={idx} key={fac.facilityModel.facilityID} value={fac.facilityModel.facilityID}>{fac.facilityModel.facilityNumber && fac.facilityModel.facilityNumber + " - "}{fac.facilityModel.facilityName}</Option>)}
                                    </Select>
                                }
                                    
                                </div>
                                <div className="form-group col col-lg-6 col-12">
                                    <div className="form-label">BIRADS <span className="color-pink">*</span></div>
                                    <Select
                                        mode="multiple"
                                        maxTagCount={1}
                                        allowClear
                                        placeholder="Please select"
                                        onChange={this.handleBiradChange}
                                        className="form-control-custom w-100"
                                    bordered={false}
                                    virtual={false}
                                        value={this.state.selectedBirads}
                                    >
                                        <Option key="Select All" value="Select All">Select All</Option>
                                        <Option key="No Result Entered" value="No Result Entered">No Result Entered</Option>
                                        {this.state.availableBirads?.map((b, idx) => <Option key={b.birads} value={b.birads}>{b.birads}</Option>)}
                                    </Select>
                                </div>
                            </div>


                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-submit float-left" onClick={this.handleSubmit} style={{ left: '10px', position: 'fixed', backgroundColor: '#1D6F42', borderColor: '#1D6F42'}}>Export to PDF</button>
                    <div className="row">
                        <div className="form-group col-12 padding-25-10">
                            
                            <button className="btn btn-submit" onClick={this.exportExcel}>Run Report</button>
                            <button className="btn btn-outline-default margin-left-15" onClick={this.handleClear}>Clear</button>
                            <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={() => this.props.hideModal()}>Cancel</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(OpenExamsReportModal);